import React, { useState, useEffect } from "react";
import Alert from "../../../Components/alert/Alert";
import TextField from "../../../Components/textField/textField";
import Select from "../../../Components/select/select";
import Button from "../../../Components/commonButton/commonButton";
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";
import Api from "../../../services/api";
import { Checkbox } from "../../../Components/Checkbox/checkbox";

const AltUser = () => {
  const [message, setMessage] = useState("");
  const [show, setShow] = useState(false);
  const [reload, setReload] = useState(false);
  const [disabled, setDisabled] = useState(true);

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [level, setLevel] = useState("");
  const [password, setPassword] = useState("");
  const [confPassword, setConfPassword] = useState("");
  const [admin, setAdmin] = useState(false);
  const [validated, setValidated] = useState(false);

  const [selectUsers, setSelectUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [users, setUsers] = useState([]);

  const [notification, setNotification] = useState(false);
  const [notification_type, setNotificationType] = useState("success");
  const [notification_message, setNotificationMessage] = useState("");

  const levels = [
    { value: "Insp./Prep./Ferram.", label: "Insp./Prep./Ferram." },
    { value: "Supervisor", label: "Supervisor" },
    { value: "Coordenador", label: "Coordenador" },
    { value: "Gerente", label: "Gerente" },
    { value: "Diretor", label: "Diretor" },
  ];

  //Puxando todos os usuários

  const getAllUsers = () => {
    let arr = [];
    Api.get("/users/")
      .then((response) => {
        response.data.forEach((user) => {
          arr.push({ value: user.id, label: user.username });
        });
        setSelectUsers(arr);
        setUsers(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getAllUsers();
  }, []);

  const validationForm = () => {
    if (email.length > 320) {
      setMessage("O campo e-mail pode ter no máximo 320 caracteres.");
      setShow(true);
      return false;
    }

    if (username.length > 20) {
      setMessage("O campo usuário pode ter no máximo 20 caracteres.");
      setShow(true);
      return false;
    }

    if (username == "" || email == "" || level == "") {
      setMessage("Erro! Todos os dados devem ser preenchidos.");
      setShow(true);
      return false;
    }

    if (password != confPassword) {
      setMessage("Erro! As senhas não conferem.");
      setShow(true);
      return false;
    }

    if (selectedUser == null) {
      setMessage("Erro! Você não selecionou nenhum usuário.");
      setShow(true);
      return false;
    }

    return true;
  };

  //Função para enviar dados aos backend
  const sendData = () => {
    if (validationForm() == true) {
      Api.put("/users/" + selectedUser, {
        username: username,
        email: email,
        level: level,
        is_admin: admin,
        is_validated: validated,
        id_employee: null,
      })
        .then((response) => {
          setNotification(true);
          setNotificationType("success");
          setNotificationMessage("Usuário alterado com sucesso!");
          setTimeout(() => {
            return window.location.reload();
          }, 2000);
        })
        .catch((error) => {
          setMessage(
            "Erro ao alterar usuário! Verifique os dados e tente novamente."
          );
          setShow(true);
          console.log(error);
        });
    }
  };

  //Função para fechar o alerta
  const callbackfunction = () => {
    setShow(false);
  };

  //Função para armazenar o usuário
  const callbackUsername = (value) => {
    setUsername(value);
  };

  //Função para armazenar o email
  const callbackEmail = (value) => {
    setEmail(value);
  };

  //Função para armazenar o level
  const callbackLevel = (value) => {
    setLevel(value);
  };

  //Função para armazenar a senha
  const callbackPassword = (value) => {
    setPassword(value);
  };

  //Função para armazenar a confirmação da senha
  const callbackConfPassword = (value) => {
    setConfPassword(value);
  };

  const callbackAdmin = (value) => {
    setAdmin(value);
  };

  const callbackValidated = (value) => {
    setValidated(value);
  };

  const selectUser = (value) => {
    let user = users.find((item) => item.id == value);
    if (user != null) {
      setSelectedUser(user.id);
      setUsername(user.username);
      setEmail(user.email);
      setLevel(user.level);
      setAdmin(user.is_admin);
      setValidated(user.is_validated);
      setDisabled(false);
    }
  };

  return (
    <div className="box">
      {notification == true ? (
        <>
          <Notification
            message={notification_message}
            type={notification_type}
          ></Notification>
          <Loading></Loading>
        </>
      ) : (
        <></>
      )}
      {show ? (
        <Alert
          show={show}
          message={message}
          parentCallback={callbackfunction}
          reload={reload}
        />
      ) : null}
      <form className="form">
        <h4>Alterar Usuários</h4>
        <div className="inputs">
          <div className="element">
            <Select
              label={"Usuários"}
              arrData={selectUsers}
              handleSelect={selectUser}
            ></Select>
          </div>
          <div className="element">
            <TextField
              readOnly={disabled}
              max={20}
              title={"Usuário"}
              validationType={"varchar"}
              value={username}
              parentCallback={callbackUsername}
            ></TextField>
          </div>
          <div className="element">
            <TextField
              readOnly={disabled}
              max={320}
              title={"E-mail"}
              value={email}
              parentCallback={callbackEmail}
            ></TextField>
          </div>
          <div className="element">
            <Select
              isDisabled={disabled}
              label={"Nível ANDON"}
              arrData={levels}
              selectedID={{ value: level, label: level }}
              handleSelect={callbackLevel}
            ></Select>
          </div>
          <div className="checkboxs">
              <Checkbox label="Administrador" checked={admin} id="administrador" setIsActive={callbackAdmin}/>
          </div>
        </div>
        <div className="submitButton">
          <Button
            icon="alt"
            disabled={disabled}
            parentCallback={sendData}
            title="Alterar"
          ></Button>
        </div>
      </form>
    </div>
  );
};

export default AltUser;
